export const basePath = (path?: string): string =>
    `/app/scheduling${path ? `/${path}` : ''}`;
